import * as React from 'react';

function SvgNASCAR(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="16px" viewBox="0 0 16 16" width="16px" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path
          d="M7.428 0c3.39 0 6.563 2.34 7.317 5.306h.143c.166.01.318.1.408.239 1.232 1.846.578 5.273.058 6.828a.527.527 0 01-.498.36.443.443 0 01-.154 0l-.716 1.752a1.24 1.24 0 01-1.172.774c-.101 0-.2-.011-.298-.037L1.698 12.516a1.23 1.23 0 01-.828-.68A15.157 15.157 0 010 6.899C0 3.22 3.47 0 7.428 0zm7.11 6.367h-.133a.53.53 0 01-.27-.037L8.25 5.958a2.077 2.077 0 01-.419 2.468l.287.096a.521.521 0 01.207.126l1.496 1.496 4.68 1.402c.435-1.534.71-3.884.037-5.179zm-8.182-.531a1.24 1.24 0 00-1.222 1.251 1.24 1.24 0 002.482 0 1.241 1.241 0 00-1.222-1.251h-.038zm-4.5 5.555a.168.168 0 00.118.096l10.84 2.705a.174.174 0 00.206-.1l.653-1.688-4.276-1.262a.603.603 0 01-.223-.133L7.672 9.502 6.24 9.03a2.124 2.124 0 11.127-4.245H6.4l7.216.451c-.801-2.33-3.454-4.176-6.187-4.176-3.396 0-6.367 2.728-6.367 5.837.022 1.531.291 3.048.796 4.493v.001z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default SvgNASCAR;
